// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyAXYd-_VIIJ80dCBva9sfdIQntwCbuytvc",
    authDomain: "capitaltracker-1c513.firebaseapp.com",
    projectId: "capitaltracker-1c513",
    storageBucket: "capitaltracker-1c513.firebasestorage.app",
    messagingSenderId: "877064137382",
    appId: "1:877064137382:web:1ab16a3a97b46c4437a267"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };